export default __webpack_public_path__ + "static/media/zenodo-home.97c55b63.png";